import React from "react";
import "./reports.scss";
import Buttons from "../../../library/custom/button/Button";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import SelectMenu from "../../../library/custom/selectMenu/SelectMenu";
import FormControl from "@mui/material/FormControl";
import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import {
  API_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  SELECT_USER_TYPE,
} from "../../../constant/constant";
import { REPORTS_ANALYTICS_DASHBOARD } from "../../../constant/routeContant";
import ReportCredentialList from "./reportCredentialList";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import SearchAutoComplete from "../../../library/custom/searchAutoComplete/SearchAutoComplete";
import { getFormatedDate } from "../../../utils/helper";
import BackBtn from "../../../library/custom/backBtn/backBtn";
function ReportCredentialCount({
  NavigateToLookup,
  CredentialReportData,
  userGroups,
  getCredentialReports,
  getLookupCredentialReportData,
  getLookupCredentialReports,
  isLoading,
  PAGE_SIZES,
  handleAllGroupSearch,
  location,
  clearDtaReports,
  getCredentialListData,
}) {
  const dataBack = {
    title: "Back",
    route: location?.state?.apiData?.tab ? REPORTS_ANALYTICS_DASHBOARD : -1,
    state: {
      apiData: location?.state?.apiData,
      backpage: "backpage",
      tab: location?.state?.apiData?.tab,
    },
  };
  const [userType, setUserType] = useState(SELECT_USER_TYPE[0].key);
  const [credentialTabId, setCredentialTabId] = useState("");
  const [names, Setnames] = useState("");
  const [groupId, SetgroupId] = useState("");
  const [showList, setShowList] = useState(false);
  const [group, setgroup] = useState(0);
  const [groupName, setgroupName] = useState("");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [days, setDays] = useState("");
  const [tabClicked, setTabClicked] = useState(false);
  const componentRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (location?.state?.tabId && !tabClicked) {
      setDays("");
      setCredentialTabId(location?.state?.tabId);
      setShowList(true);
      OnClickHnadler(
        group,
        location?.state?.tabId,
        location?.state?.name,
        "",
        "",
        location?.state?.divisionId ?? "",
        page,
        false
      );
    } else {
      setCredentialTabId("");
    }
  }, [location]);

  useEffect(() => {
    if (
      getLookupCredentialReportData.status === API_STATUS.SUCCESS &&
      credentialTabId
    ) {
      setShowList(true);
    }
  }, [getLookupCredentialReportData]);

  const onChangeSelectUserType = (e) => {
    setgroup("");
    setgroupName("");
    const defaultData = {
      groupId: 0,
    };
    getCredentialReports(defaultData);
    setUserType(e.target.value);
  };

  const onChangeUsersGroup = (value) => {
    if (value) {
      const defaultData = {
        groupId: value.key,
      };
      getCredentialReports(defaultData);
      setgroup(value.key);
      setgroupName({
        key: value.key,
        value: value.value,
      });
    }
  };

  const OnClickHnadler = (
    group,
    tabId,
    name,
    startDate,
    endDate,
    divisionId,
    page1,
    isSendMail
  ) => {
    setPage(1);
    clearDtaReports();
    setData([]);
    Setnames(name);
    SetgroupId(group);
    setDays("");
    getLookupCredentialReports(
      group,
      tabId,
      startDate ? getFormatedDate(startDate) : "",
      endDate ? getFormatedDate(endDate) : "",
      divisionId === "AllDivision" ? 0 : divisionId ?? 0,
      page1,
      isSendMail
    );

    setCredentialTabId(tabId);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Credential Report",
    fonts: ["Lato"],
    bodyClass: "bodyPdf",
  });

  const isClient = ORG_ID() !== LOGIN_ORG_ID();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const clientLogo = localStorage.getItem("orgLogo");
  const clientName = localStorage.getItem("orgName");
  const logoCheck = isClient ? clientLogo : userInfo?.logo;

  const cardData = [
    {
      id: 0,
      label: "Total Credential",
      key: "totalCredentials",
      title: "Total Credentials",
    },
    {
      id: 1,
      label: "Expiring Credentials",
      key: "expiringCredentials",
      title: "Expiring Credentials",
    },
    {
      id: 2,
      label: "Expired Credentials",
      key: "expiredCredentials",
      title: "Expired Credentials",
    },
    {
      id: 3,
      label: "Assigned Credentials",
      key: "assignedCredentials",
      title: "Assigned Credentials",
    },
    {
      id: 4,
      label: "Configured Credentials",
      key: "configuredCredentials",
      title: "Configured Credentials",
    },
    {
      id: 5,
      label: "Incomplete Credentials",
      key: "incompleteCredentials",
      title: "Incomplete Credentials",
    },
  ];

  const handleCardClick = (tabId, label) => {
    setTabClicked(true);
    setPage(1);
    setCredentialTabId(tabId);
    setStartDate(null);
    setEndDate(null);
    OnClickHnadler(
      group,
      tabId.toString(),
      label,
      "",
      "",
      location?.state?.divisionId ?? "",
      1,
      false
    );
  };
  const downloadCredentialOverviewMail = () => {
    const defaultDatas = {
      page: 1,
      pageSize: PAGE_SIZES,
      groupId: group ? group : 0,
      orgId: parseInt(ORG_ID()),
      tabId: parseInt(credentialTabId),
      startDate: startDate ? getFormatedDate(startDate) : "",
      endDate: endDate ? getFormatedDate(endDate) : "",
      divisionId:
        location?.state?.divisionId === "AllDivision"
          ? 0
          : location?.state?.divisionId ?? 0,
      isSendMail: true,
    };

    getCredentialListData(defaultDatas);
  };
  return (
    <>
      <div>
        <BackBtn dataBack={dataBack} />
      </div>

      <div ref={componentRef} className="innerReportAndAnalyticsPdf">
        <section className="grid_main_sec">
          <Grid item md={12} className="clientPdfDetail">
            <Grid className="clientName">
              {isClient ? clientName : userInfo?.clientName}
            </Grid>
            <Grid className="clientLogo">
              {logoCheck && <img src={logoCheck} alt="client Log" />}
            </Grid>
          </Grid>
          <Grid container lg={12}>
            <Grid lg={4}>
              <div className="grid_main_header two_grid">
                <div className="grid_heading_style repotPdfHeading">
                  Credential Reports
                </div>
              </div>
            </Grid>
            <Grid lg={8} className="right-side-section">
              <Grid>
                <Buttons
                  primary={true}
                  id="btnAddClient"
                  label={"Credential Lookup"}
                  onClick={NavigateToLookup}
                ></Buttons>
              </Grid>
              {credentialTabId && (
                <Grid>
                  <Buttons
                    primary={true}
                    id="btnAddClient"
                    label={"Download Credential Overview"}
                    onClick={downloadCredentialOverviewMail}
                  ></Buttons>
                </Grid>
              )}
            </Grid>
          </Grid>
        </section>

        <Grid container mt={2} className="removeElement">
          <Grid item lg={4} xs={12} sm={12} md={4}>
            <FormControl fullWidth>
              <FormLabels label="Select User Type" isRequired={false} />
              <SelectMenu
                placeholder="Please Select"
                listData={SELECT_USER_TYPE}
                value={userType}
                onchangehandler={(e) => onChangeSelectUserType(e)}
              />
            </FormControl>
          </Grid>
        </Grid>
        {userType == 2 && (
          <Grid container mt={2} className="removeElement">
            <Grid item lg={4} xs={12} sm={12} md={4}>
              <FormControl fullWidth>
                <FormLabels label="Search Group" isRequired={false} />

                <SearchAutoComplete
                  name="Search User Group"
                  optionsData={isLoading ? [] : userGroups?.groupList ?? []}
                  typeOnchange={(event) =>
                    handleAllGroupSearch(event.target.value, 0, true)
                  }
                  isKeyValuePair={true}
                  value={groupName}
                  onChange={(e, value) => onChangeUsersGroup(value)}
                  isLoading={isLoading}
                  noOptionsTextMsg="No Groups"
                />
              </FormControl>
            </Grid>
          </Grid>
        )}

        <div className="reportBody">
          {cardData?.map(({ id, label, key, title }) => (
            <div
              key={id}
              className={
                parseInt(credentialTabId) === id
                  ? "reportCardBody borderBlue"
                  : "reportCardBody"
              }
              onClick={() => handleCardClick(id, label)}
            >
              <div className="text">{title}</div>
              <div className="number">
                {CredentialReportData?.data?.result?.[key]}
              </div>
            </div>
          ))}
        </div>

        {showList && (
          <Grid>
            <ReportCredentialList
              getLookupCredentialReportData={getLookupCredentialReportData}
              getLookupCredentialReports={getLookupCredentialReports}
              // isLoading={isLoading}
              credentialTabId={credentialTabId}
              groupId={groupId}
              PAGE_SIZES={PAGE_SIZES}
              namess={names}
              location={location}
              data={data}
              setData={setData}
              setPage={setPage}
              page={page}
              setDays={setDays}
              days={days}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </Grid>
        )}
      </div>
    </>
  );
}

export default ReportCredentialCount;
